import { css, themes } from '@kawaui/theme'

const {
  default: {
    breakpoint: { tablet, desktop, desktopHD },
  },
} = themes

export const STATIC = 'https://static.vente-privee.com/vp5'

export const numerify = (number: string) => parseInt(number.replace('px', '').trim(), 10)

export const MOBILE_MAX = `${numerify(tablet) - 1}px`
export const TABLET_MAX = `${numerify(desktop) - 1}px`

export const BREAKPOINTS = {
  // Generics
  small: `(max-width: ${MOBILE_MAX})`,
  medium: `(min-width: ${tablet}) and (max-width: ${TABLET_MAX})`,
  big: `(min-width: ${desktop})`,
  large: `(min-width: ${desktopHD})`,
  // Extras
  noMobile: `(min-width: ${tablet})`,
  // Mix
  smallDevice: `(max-width: ${TABLET_MAX})`,
  bigDevice: `(min-width: ${desktop})`,
}

export const isIE = '(-ms-high-contrast: none)'

// VPSansNext-Medium
export const titleMedium = css`
  margin: 0;

  font-family: ${({ theme }) => theme.fontFamily.title};
  font-weight: 500;
`
// VPSansNext-Bold
export const titleBold = css`
  margin: 0;

  font-family: ${({ theme }) => theme.fontFamily.title};
  font-weight: 700;
`

// HKGrotesk-Medium
export const textMedium = css`
  margin: 0;

  font-family: ${({ theme }) => theme.fontFamily.text};
  font-weight: normal;
`

// HKGrotesk-SemiBold
export const textSemiBold = css`
  margin: 0;

  font-family: ${({ theme }) => theme.fontFamily.text};
  font-weight: 600;
`

// HKGrotesk-Bold
export const textBold = css`
  margin: 0;

  font-family: ${({ theme }) => theme.fontFamily.text};
  font-weight: 700;
`
export const headerHeight = '120px'

export const mobileHeaderHeight = css`
  ${({ theme }) => theme.space.s600}
`
export const mobileHeaderMarginBottom = css`
  ${({ theme }) => theme.space.s200}
`

const VEEPEE_DEFAULT = 'VEEPEE_DEFAULT'
const VEEPEE_PURPLE = 'VEEPEE_PURPLE'
const PRIVALIA = 'PRIVALIA'
export const Themes = {
  VEEPEE_DEFAULT,
  VEEPEE_PURPLE,
  PRIVALIA,
}

export const MODAL_WIDTH = '530px'
export const MODAL_HEIGHT = '700px'
